import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AreaType } from 'types/area';

interface AreasPayload extends Omit<PayloadAction, 'payload'> {
  payload: { areas: AreaType[] };
}

interface AreaPayload extends Omit<PayloadAction, 'payload'> {
  payload: { area: AreaType };
}

const initialValue: AreaType[] = [];

export const areasSlice = createSlice({
  name: 'areas',
  initialState: {
    value: initialValue,
  },
  reducers: {
    add: (state, action: AreaPayload) => {
      const { area } = action.payload;
      state.value = [
        ...state.value,
        {
          id: area.id,
          name: area.name,
          icon: area.icon,
          coordinates: area.coordinates,
          description: area.description,
        },
      ];
    },
    change: (state, action: AreaPayload) => {
      const { area } = action.payload;
      state.value = state.value.map((r) => {
        if (r.id === area.id) {
          return area;
        } else {
          return r;
        }
      });
    },
    remove: (state, action: { payload: { id: string } }) => {
      const { id } = action.payload;
      state.value = state.value.filter((r) => r.id !== id);
    },
    replace: (state, action: AreasPayload) => {
      state.value = action.payload.areas;
    },
  },
});

// Action creators are generated for each case reducer function
export const { add, change, remove, replace } = areasSlice.actions;
export const selectAllAreas = (state) => state.areas;

export default areasSlice.reducer;
